import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRippleModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';

// import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

// import { FilePondModule, registerPlugin } from 'ngx-filepond';
// import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
// import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
// import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
// import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
// import FilePondPluginImageResize from 'filepond-plugin-image-resize';
// registerPlugin(FilePondPluginFileValidateType);
// registerPlugin(FilePondPluginFileValidateSize);
// registerPlugin(FilePondPluginImagePreview);
// registerPlugin(FilePondPluginImageTransform);
// registerPlugin(FilePondPluginImageResize);
// import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

// import { RedZoomModule } from 'ngx-red-zoom';

// import { SharedModule } from '@app/@shared';
// import { TranslateLandPipe } from '@app/@shared/pipe/translate-land.pipe';

import { ZahlungEditComponent } from './zahlung_edit.component';

// import { DatePipe } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatRippleModule,
    MatCardModule,
    MatTooltipModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatDialogModule,
  ],
  exports: [ZahlungEditComponent],
  declarations: [ZahlungEditComponent],
  providers: [],
})
export class ZahlungEditModule {}
